import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { TransferConstructionSitePrintModel } from 'src/app/models/rental/transfer-construction-site-print.model';
import { TransferConstructionSiteModel } from 'src/app/models/rental/transfer-construction-site.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class TransferConstructionSiteService {

  constructor(private _httpClient: HttpClient) { }

  confirmTransferConstructionSite(id: number): Observable<TransferConstructionSiteModel> {
    return this._httpClient.put<TransferConstructionSiteModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.ConfirmTransferConstructionSite}/${id}`,
      null);
  }

  getTransferConstructionSiteById(transferConstructionSiteId: number): Observable<TransferConstructionSiteModel> {
    return this._httpClient.get<TransferConstructionSiteModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.GetTransferConstructionSiteById}/${transferConstructionSiteId}`);
  }

  createTransferConstructionSite(transferConstructionSiteContract: TransferConstructionSiteModel): Observable<TransferConstructionSiteModel> {
    return this._httpClient.post<TransferConstructionSiteModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.CreateTransferConstructionSite}`,
      transferConstructionSiteContract);
  }

  updateTransferConstructionSite(transferConstructionSiteContract: TransferConstructionSiteModel): Observable<TransferConstructionSiteModel> {
    return this._httpClient.put<TransferConstructionSiteModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.UpdateTransferConstructionSite}`,
      transferConstructionSiteContract);
  }

  deleteTransferConstructionSite(transferConstructionSiteId: number): Observable<TransferConstructionSiteModel> {
    return this._httpClient.delete<TransferConstructionSiteModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.DeleteTransferConstructionSite}/${transferConstructionSiteId}`);
  }

  annulTransferConstructionSite(transferConstructionSiteId: number): Observable<TransferConstructionSiteModel> {
    return this._httpClient.put<TransferConstructionSiteModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.AnnulTransferConstructionSite}/${transferConstructionSiteId}`,
      null);
  }

  setStateTransferConstructionSite(transferConstructionSiteId: number): Observable<TransferConstructionSiteModel> {
    return this._httpClient.put<TransferConstructionSiteModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.SetTransferConstructionSiteState}/${transferConstructionSiteId}`,
      null);
  }

  getTransferConstructionSiteByKeysAsync(branchId: number, consecutive: number): Observable<TransferConstructionSiteModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<TransferConstructionSiteModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.GetTransferConstructionSiteByKeys}`, { params: params });
  }

  getFirstTransferConstructionSiteByKeysAsync(branchId: number): Observable<TransferConstructionSiteModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<TransferConstructionSiteModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.GetFirstTransferConstructionSiteByKeys}`, { params: params });
  }

  getNextTransferConstructionSiteByKeysAsync(branchId: number, consecutive: number): Observable<TransferConstructionSiteModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<TransferConstructionSiteModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.GetNextTransferConstructionSiteByKeys}`, { params: params });
  }

  getLastTransferConstructionSiteByKeysAsync(branchId: number): Observable<TransferConstructionSiteModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<TransferConstructionSiteModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.GetLastTransferConstructionSiteByKeys}`, { params: params });
  }

  getPreviusTransferConstructionSiteByKeysAsync(branchId: number, consecutive: number): Observable<TransferConstructionSiteModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<TransferConstructionSiteModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.GetPreviusTransferConstructionSiteByKeys}`, { params: params });
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.GetColumnsForGeneralConsultation}`);
  }

  getTransferConstructionSiteWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.GetAlltransferConstructionSitesWithPagination}`,
      filters, { params: params }
    );
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllCostCenterForOriginSelect(branchId: number): Observable<Array<any>> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.GetAllCostCenterForOriginSelectAsync}`,
      { params: params }
    );
  }

  getAllCostCenterForDestinitySelect(branchId: number): Observable<Array<any>> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.GetAllCostCenterForDestinitySelectAsync}`,
      { params: params }
    );
  }

  getAllTransporterForSelect(branchId: number): Observable<Array<any>> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.GetAllTransporterForSelectAsync}`,
      { params: params }
    );
  }

  getAllBranchesForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.GetAllBranchesForSelectAsync}`);
  }

  getAllVehicleForSelect(branchId: number): Observable<Array<any>> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.GetAllVehicleForSelectAsync}`,
      { params: params }
    );
  }

  getPermissionTransferConstructionSite(permission: number): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.GetPermission}/${permission}`);
  }

  getClientsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.GetClientsForSelectAsync}`);
  }

  getClientByCostCenterIdAsync(CostCenterId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.GetClientByCostCenterIdAsync}/${CostCenterId}`);
  }

  getRentalPeriodByIdForRegisterInvoiceAsync(rentalPeriodId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.GetRentalPeriodByIdForRegisterInvoiceAsync}/${rentalPeriodId}`,);
  }

  getPermissionPrint(): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.GetPermissionPrint}`);
  }

  howManyTranfersInTransitByUserAuthenticated(): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.HowManyTranfersInTransitByUserAuthenticated}`);
  }

  printTransferConstructionSite(transferConstructionSiteId: number, print: boolean): Observable<TransferConstructionSitePrintModel> {
    let params = new HttpParams()
    params = params.set('transferConstructionSiteId', transferConstructionSiteId.toString());
    params = params.set('print', print);
    return this._httpClient.get<TransferConstructionSitePrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.transferConstructionSite.PrintTransferConstructionSite}`,
      { params: params }
    );
  }
}
